export enum DonationOption {
  IN_CIRCLE,
  PUBLIC,
}
